<div class="my-5">
    <sm-page-header [breadcrumb]="breadcrumb" title="settings.paymentJustification.title">
    </sm-page-header>

    <div class="content">
        <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data" [loading]="loading"
            [totalRecords]="totalRecords">
        </sm-data-table-builder>
    </div>

    <sm-drawer #drawer [drawer]="detailDrawer"></sm-drawer>
    <sm-dialog #dialog [dialog]="dialogObject"></sm-dialog>
</div>